/**
 * OX 퀴즈 — 정답/오답 영상 오버레이 (Figma `3481:47885`, 2026-08-13 취득)
 *
 * 사용자 요청 원문: *"답을 맞추면 … 정답 영상을 퀴즈화면 위에 오버레이 해서 영상을
 * 보여주고(반투명 레이어로), 틀리면 ox퀴즈의 오답영상을 동일한 형식으로"*
 *
 * 🔴 **문제 화면을 가리지 않는다.** `rgba(255,255,255,0.6)` + `backdrop-filter: blur(25px)` 라
 *    아래 문제·이미지가 흐릿하게 비친다. 불투명하게 덮으면 "오버레이" 가 아니라 화면 전환이
 *    되어 요구와 달라진다(CSS 가드가 알파 1 을 막는다).
 *
 * 🔴 정오 판정은 **표시용**이다. 저장·정산의 권위는 서버 재채점(D10)이고 `onComplete`
 *    페이로드는 바뀌지 않는다 — 어느 영상을 틀지 고르는 데만 쓴다.
 *
 * 워치독은 `useQuestVideoWatchdog` 이 소유한다(3화면과 동일) — 영상이 어떤 이유로 멈춰도
 * 반드시 `onFinished` 로 빠져나가 완료 화면으로 넘어간다.
 *
 * 회귀 가드: OxQuizVerdict.test.jsx
 */
import React from 'react';
import useQuestVideoWatchdog from '../../hooks/useQuestVideoWatchdog';
import './OxQuizFlow.css';

export default function OxVerdictOverlay({ videoUrl, onFinished, onAbort }) {
  const { videoRef, videoPlaying, isVideoPhase, videoHandlers } = useQuestVideoWatchdog({
    active: true,
    videoUrl,
    onFinished,
    onAbort,
    logLabel: 'OX 정답/오답 영상',
  });

  // URL 이 없으면 훅이 즉시 onFinished 를 부른다(부모가 건너뛰도록 라우팅하지만 이중 방어).
  // 🔴 빈 오버레이가 한 프레임이라도 뜨면 문제 화면이 이유 없이 흐려졌다 돌아온다.
  if (!isVideoPhase) return null;

  return (
    <div className="oxq-verdict-overlay" data-testid="ox-verdict-overlay">
      <video
        ref={videoRef}
        /* 재생이 시작되기 전에는 감춘다 — 네이티브 재생 오버레이가 잠깐 보이던 문제(2026-08-18).
           CSS 의 `.oxq-verdict-video { opacity: 0 }` 와 짝이다. */
        className={`oxq-verdict-video${videoPlaying ? ' oxq-verdict-video-playing' : ''}`}
        src={videoUrl}
        autoPlay
        playsInline
        preload="auto"
        aria-label="OX 퀴즈 정답 확인 영상"
        data-testid="ox-verdict-video"
        {...videoHandlers}
      />
    </div>
  );
}
